import { ApiCrudObjectControllerBindings, PaymentChannelController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Shows a print-like preview for an invoice.
 * @example
 * ```html
 * <salaxy-payment-channel-invoice-preview model="$ctrl.current"></salaxy-payment-channel-invoice-preview>
 * ```
 */
export class PaymentChannelInvoicePreview extends ComponentBase {

    /**
     * The following component properties (attributes in HTML) are bound to the Controller.
     * For detailed functionality, refer to [controller](#controller) implementation.
     */
    public bindings = new ApiCrudObjectControllerBindings();

    /** Uses the PaymentChannelController */
    public controller = PaymentChannelController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/invoices/InvoicePreview.html";

}
